var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"387.03","y":"224.61","width":"18.71","height":"172","transform":"translate(-428 132.57) rotate(-45)","style":{"stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"9px"},"key":0}),React.createElement("rect",{"x":"387.18","y":"224.66","width":"18.53","height":"172","transform":"translate(132.64 571.97) rotate(-135)","style":{"stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"9px"},"key":1})]);
}

Cross.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 143.85 143.85"};

module.exports = Cross;

Cross.default = Cross;
